type InsightType =
  | "cumulative-people"
  | "occupancy-people"
  | "queue-people"
  | "cumulative-shopping-cart"
  | "occupancy-shopping-cart"
  | "queue-shopping-cart"
  | "cumulative-vehicle"
  | "occupancy-vehicle"
  | "queue-vehicle"
  | "slip-and-fall"
  | "crowd-count"
  | "visitor-area-traffic"
  | "stopped-vehicle"
  | "slow-traffic";

type DataType =
  | "PEOPLE_COUNT"
  | "QUEUE_MANAGEMENT"
  | "SLIP_AND_FALL"
  | "CROWD_COUNT"
  | "SHOPPING_CART_COUNT"
  | "SHOPPING_CART_QUEUE_MANAGEMENT"
  | "VEHICLE_COUNT"
  | "VEHICLE_QUEUE_MANAGEMENT"
  | "STOPPED_VEHICLE"
  | "TRAFFIC_JAM";

type DeviceData = {
  locationId: string;
};

type GroupedData = Record<string, Record<string, DeviceData[]>>;

const DEFAULT_INSIGHT_TYPE: InsightType = "cumulative-people";
const DEFAULT_DATA_TYPE: DataType = "PEOPLE_COUNT";

const titleToInsightTypeMap: Record<string, InsightType> = {
  CUMULATIVE_PEOPLE_COUNT: "cumulative-people",
  PEOPLE_OCCUPANCY: "occupancy-people",
  PEOPLE_QUEUES: "queue-people",
  RETAIL_VISITOR_AREA_TRAFFIC: "visitor-area-traffic",
  CROWD_COUNTING: "crowd-count",
  SLIP_AND_FALL: "slip-and-fall",
  CUMULATIVE_SHOPPING_CART_COUNT: "cumulative-shopping-cart",
  SHOPPING_CARTS_IN_USE: "occupancy-shopping-cart",
  SHOPPING_CART_QUEUES: "queue-shopping-cart",
  CUMULATIVE_VEHICLE_COUNT: "cumulative-vehicle",
  VEHICLE_OCCUPANCY: "occupancy-vehicle",
  VEHICLE_QUEUES: "queue-vehicle",
  STOPPED_VEHICLE_ANALYTICS: "stopped-vehicle",
  SLOW_TRAFFIC: "slow-traffic"
};

const titleToDataTypeMap: Record<string, DataType> = {
  CUMULATIVE_PEOPLE_COUNT: "PEOPLE_COUNT",
  PEOPLE_OCCUPANCY: "PEOPLE_COUNT",
  PEOPLE_QUEUES: "QUEUE_MANAGEMENT",
  RETAIL_VISITOR_AREA_TRAFFIC: "QUEUE_MANAGEMENT",
  SLIP_AND_FALL: "SLIP_AND_FALL",
  CROWD_COUNTING: "CROWD_COUNT",
  CUMULATIVE_SHOPPING_CART_COUNT: "SHOPPING_CART_COUNT",
  SHOPPING_CARTS_IN_USE: "SHOPPING_CART_COUNT",
  SHOPPING_CART_QUEUES: "SHOPPING_CART_QUEUE_MANAGEMENT",
  CUMULATIVE_VEHICLE_COUNT: "VEHICLE_COUNT",
  VEHICLE_OCCUPANCY: "VEHICLE_COUNT",
  VEHICLE_QUEUES: "VEHICLE_QUEUE_MANAGEMENT",
  STOPPED_VEHICLE_ANALYTICS: "STOPPED_VEHICLE",
  SLOW_TRAFFIC: "TRAFFIC_JAM"
};

export const useInsightTypeConverter = () => {
  const labelToInsightType = (label: string): InsightType => {
    return titleToInsightTypeMap[label] ?? DEFAULT_INSIGHT_TYPE;
  };

  const labelToDataType = (label: string): DataType => {
    return titleToDataTypeMap[label] ?? DEFAULT_DATA_TYPE;
  };

  const getGroupByTypeAndLocationId = (
    data: GroupedData,
    type: string,
    targetLocationId: string
  ): Record<string, DeviceData[]> | null => {
    const group = data?.[labelToDataType(type)];
    if (!group) return null;

    const entry = Object.entries(group).find(([, items]) =>
      items.some((item) => item.locationId === targetLocationId)
    );

    return entry ? { [entry[0]]: entry[1] } : group;
  };

  return {
    labelToInsightType,
    getGroupByTypeAndLocationId
  };
};
